import React from 'react';
import chartColors from '../../../const/chartColors';
import {Environment} from '../../../const/environment';

export function getBarChartGradients() {
    return <defs>
        <linearGradient id={`${Environment.Staging}ColorVertical`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={chartColors[Environment.Staging].color0} stopOpacity={1} />
            <stop offset="100%" stopColor={chartColors[Environment.Staging].color2} stopOpacity={1} />
        </linearGradient>
        <linearGradient id={`${Environment.Testing}ColorVertical`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={chartColors[Environment.Testing].color0} stopOpacity={1} />
            <stop offset="100%" stopColor={chartColors[Environment.Testing].color2} stopOpacity={1} />
        </linearGradient>
        <linearGradient id={`${Environment.Production}ColorVertical`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={chartColors[Environment.Production].color0} stopOpacity={1} />
            <stop offset="100%" stopColor={chartColors[Environment.Production].color2} stopOpacity={1} />
        </linearGradient>
        <linearGradient id={`${Environment.Staging}ColorVerticalExternal`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={chartColors[Environment.Staging].color0} stopOpacity={1} />
            <stop offset="100%" stopColor={chartColors[Environment.Staging].color2} stopOpacity={1} />
        </linearGradient>
        <linearGradient id={`${Environment.Staging}ColorVerticalInternal`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={chartColors[Environment.Staging].color6} stopOpacity={1} />
            <stop offset="100%" stopColor={chartColors[Environment.Staging].color5} stopOpacity={1} />
        </linearGradient>
        <linearGradient id={`${Environment.Testing}ColorVerticalExternal`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={chartColors[Environment.Testing].color3} stopOpacity={1} />
            <stop offset="100%" stopColor={chartColors[Environment.Testing].color4} stopOpacity={1} />
        </linearGradient>
        <linearGradient id={`${Environment.Testing}ColorVerticalInternal`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={chartColors[Environment.Testing].color5} stopOpacity={1} />
            <stop offset="100%" stopColor={chartColors[Environment.Testing].color6} stopOpacity={1} />
        </linearGradient>
        <linearGradient id={`${Environment.Production}ColorVerticalExternal`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={chartColors[Environment.Production].color3} stopOpacity={1} />
            <stop offset="100%" stopColor={chartColors[Environment.Production].color4} stopOpacity={1} />
        </linearGradient>
        <linearGradient id={`${Environment.Production}ColorVerticalInternal`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={chartColors[Environment.Production].color5} stopOpacity={1} />
            <stop offset="100%" stopColor={chartColors[Environment.Production].color6} stopOpacity={1} />
        </linearGradient>
    </defs>;
}